import { PropsWithChildren } from "react";
import classNames from "classnames/bind";

import styles from "./WordopolisModal.module.scss";

const cx = classNames.bind(styles);

export interface WordopolisModalProps extends PropsWithChildren {
  className?: string;
  portalClassName?: string;
  isVisible: boolean;
  onClickOutside?: () => void;
}

export const WordopolisModal = (props: WordopolisModalProps) => {
  const { className, portalClassName, onClickOutside, isVisible, children } = props;

  return (
    <div className={cx("portal", portalClassName, { visible: isVisible })}>
      <button disabled={!onClickOutside} className={styles.background} onClick={() => onClickOutside?.()} />
      <div className={cx("wordopolisModal", className)}>{children}</div>
    </div>
  );
};
